import Helpers from '../../../common/helpers/Helpers';
import Constants from '../../../common/constants/Constants';

export const getUpdateJobDetails = (updateJobId) => {
  return Helpers.get(`${Constants.DEPLOY_PACKAGES_URL}/user/${updateJobId}`);
};

export const getUpdateJobs = () => {
  return Helpers.get(`${Constants.DEPLOYMENT_JOBS_URL}/update`);
};

export const getFleets = () => {
  return Helpers.get(Constants.FLEETS_URL);
};

export const getPackages = () => {
  return Helpers.get(`${Constants.UPDATE_PACKAGES_URL}/update`);
};

export const deployPackage = (packageId, fleetId) => {
  return Helpers.post(`${Constants.DEPLOY_PACKAGES_URL}/${packageId}/fleet/${fleetId}`);
};
